import {Company} from "./company";
import {PhaseGroup} from "./phase";
import {Project} from "./project";

export class Trade {
  id: number;
  version: number;
  company: Company;
  name: string;
  publicId: string;
  type: TradeType;
  address1: string;
  address2: string;
  city: string;
  zipCode: string;
  state: string;
  countryCode: string;
  phoneNumber: string;
  email: string;
  usersCount: number;
  projects: Project[];
  phaseGroups: PhaseGroup[];
}

export enum TradeType {
  CARPENTRY = 'CARPENTRY',
  CEILINGS_ACT = 'CEILINGS_ACT',
  CONCRETE = 'CONCRETE',
  DOORS_AND_HARDWARE = 'DOORS_AND_HARDWARE',
  DRYWALL = 'DRYWALL',
  ELECTRICAL = 'ELECTRICAL',
  ELEVATOR = 'ELEVATOR',
  FIRE_PROTECTION = 'FIRE_PROTECTION',
  FLOORING = 'FLOORING',
  GLASS_AND_GLAZING = 'GLASS_AND_GLAZING',
  HVAC_MECHANICAL = 'HVAC_MECHANICAL',
  KITCHEN_EQUIPMENT = 'KITCHEN_EQUIPMENT',
  LANDSCAPING = 'LANDSCAPING',
  LOW_VOLTAGE_FIRE_ALARM = 'LOW_VOLTAGE_FIRE_ALARM',
  MASONRY = 'MASONRY',
  MILLWORK_AND_CABINETS = 'MILLWORK_AND_CABINETS',
  PAINTING = 'PAINTING',
  PLUMBING = 'PLUMBING',
  ROOFING = 'ROOFING',
  SECURITY_ACCESS_CONTROL = 'SECURITY_ACCESS_CONTROL',
  SITEWORK_EXCAVATION = 'SITEWORK_EXCAVATION',
  STEEL = 'STEEL',
  TILE_AND_STONE = 'TILE_AND_STONE',
  WATERPROOFING = 'WATERPROOFING',
  WINDOWS_EXTERIOR_FACADE = 'WINDOWS_EXTERIOR_FACADE',
  FINAL_CLEAN_TURNOVER = 'FINAL_CLEAN_TURNOVER',
}

export const TypeLabels: Record<TradeType, string> = {
  [TradeType.CARPENTRY]: 'Carpentry',
  [TradeType.CEILINGS_ACT]: 'Ceilings (ACT)',
  [TradeType.CONCRETE]: 'Concrete',
  [TradeType.DOORS_AND_HARDWARE]: 'Doors & Hardware',
  [TradeType.DRYWALL]: 'Drywall',
  [TradeType.ELECTRICAL]: 'Electrical',
  [TradeType.ELEVATOR]: 'Elevator',
  [TradeType.FIRE_PROTECTION]: 'Fire Protection',
  [TradeType.FLOORING]: 'Flooring',
  [TradeType.GLASS_AND_GLAZING]: 'Glass & Glazing',
  [TradeType.HVAC_MECHANICAL]: 'HVAC / Mechanical',
  [TradeType.KITCHEN_EQUIPMENT]: 'Kitchen Equipment',
  [TradeType.LANDSCAPING]: 'Landscaping',
  [TradeType.LOW_VOLTAGE_FIRE_ALARM]: 'Low Voltage / Fire Alarm',
  [TradeType.MASONRY]: 'Masonry',
  [TradeType.MILLWORK_AND_CABINETS]: 'Millwork / Cabinets',
  [TradeType.PAINTING]: 'Painting',
  [TradeType.PLUMBING]: 'Plumbing',
  [TradeType.ROOFING]: 'Roofing',
  [TradeType.SECURITY_ACCESS_CONTROL]: 'Security / Access Control',
  [TradeType.SITEWORK_EXCAVATION]: 'Sitework / Excavation',
  [TradeType.STEEL]: 'Steel',
  [TradeType.TILE_AND_STONE]: 'Tile / Stone',
  [TradeType.WATERPROOFING]: 'Waterproofing',
  [TradeType.WINDOWS_EXTERIOR_FACADE]: 'Windows / Exterior Facade',
  [TradeType.FINAL_CLEAN_TURNOVER]: 'Final Clean / Turnover',
};
